import { render, staticRenderFns } from "./WorkingPickup.vue?vue&type=template&id=2b483bf2"
import script from "./WorkingPickup.vue?vue&type=script&lang=js"
export * from "./WorkingPickup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b483bf2')) {
      api.createRecord('2b483bf2', component.options)
    } else {
      api.reload('2b483bf2', component.options)
    }
    module.hot.accept("./WorkingPickup.vue?vue&type=template&id=2b483bf2", function () {
      api.rerender('2b483bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/WorkingPickup.vue"
export default component.exports